var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client';
import { captureMessage, withScope } from 'shared/domains/sentry';
import { useAccount } from 'shared/domains/users';
import { HtmlToPdfDocument } from './mutation.gql';
import { usePlastRenderInput } from './usePlastRenderInput';
export const useHtmlToPdf = () => {
    const [mutate, state] = useMutation(HtmlToPdfDocument);
    const { getRenderInput } = usePlastRenderInput();
    const { data: accountData } = useAccount();
    const { companyId } = accountData;
    const htmlToPdf = (documentId, documentName) => __awaiter(void 0, void 0, void 0, function* () {
        const renderInput = yield getRenderInput(documentId);
        if (!renderInput) {
            withScope((scope) => {
                scope.setTag('documentId', documentId);
                captureMessage('Unable to retrieve render input for html to pdf conversion', {
                    level: 'warning',
                });
            });
            return null;
        }
        const cssFileUrl = new URL('/public/pdf.css', window.location.origin).toString();
        const { content, logoUrl } = renderInput;
        const { data } = yield mutate({
            variables: { input: { companyId, content, logoUrl, title: documentName, cssFile: cssFileUrl } },
        });
        const files = (data === null || data === void 0 ? void 0 : data.response) || [];
        return files[0];
    });
    return [htmlToPdf, state];
};
